import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";

const MainTable = () => {
  const actionsButtons = ["add", "edit", "remove", "export"];

  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="funds/bank-loc"
    sortable={["Created On"]}
    deleteSuffix="/funds/bank-loc"
    columnLabelsDictionary={{
      locestablishedDate: "LOC Established Date",
      locamount: "LOC Amount",
      locrate: "LOC Rate",
      locrateEffectiveDate: "LOC Rate Effective Date",
      bankOrganization: "Bank",
      fundOrganization: "Fund"
    }}
    dataRules={[
      { field: "locamount", rule: "format", display: "dollar" },
      { field: "loanFee", rule: "format", display: "dollar" },
      { field: "cashOnHand", rule: "format", display: "dollar" },
    ]}
  />;
};

const addFormFields = (myForm, isAdd = false) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Fund", "metadata/list-organization-funds", { name: "fundOrganizationId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Bank", "orgs/list-bank-orgs", { name: "bankOrganizationId", required: true })]);
  myForm.addCenteredGroup([
    myForm.getInputField("Advance Percentage", {
      fieldType: "percent",
      required: true,
    }),
  ]);

  myForm.addCenteredGroup([myForm.getCurrencyField("Loan Fee", { required: true })]);
  myForm.addCenteredGroup([myForm.getCurrencyField("LOC Amount", { required: true, name: "locamount" })]);
  myForm.addCenteredGroup([myForm.getCalendarField("Effective Date")]);
  myForm.addCenteredGroup([myForm.getCurrencyField("Cash On Hand")]);
  myForm.addCenteredGroup([myForm.getCalendarField("Cash On Hand Effective Date")]);
  myForm.addCenteredGroup([myForm.getCalendarField("Expiry Date")]);
  myForm.addCenteredGroup([myForm.getCalendarField("LOC Established Date", { name: "locestablishedDate" })]);
  myForm.addCenteredGroup([myForm.getCurrencyField("LOC Rate", { name: "locrate"})]);
  myForm.addCenteredGroup([myForm.getCalendarField("LOC Rate Effective Date", { name: "locrateEffectiveDate" })]);
  myForm.addCenteredGroup([myForm.getCheckboxField("Is Active", isAdd ? { value: true } : {})]);
  return myForm;
};

const handleOnBlur = (fieldName, fieldValue, options) => {
  if (fieldName === "advancePercentage" && parseFloat(fieldValue.replace(/,/g, "")) > 99.99) {
    options.setInputs({ ...options.inputs, "advancePercentage": 99.99 });
  }
  else if (fieldName === "locrate" && fieldValue && parseFloat(fieldValue.replace(/,/g, "")) > 999.999) {
    options.setInputs({ ...options.inputs, "locrate": 999.999 });
  }
};

const AddBankLocForm = () => {
  const myForm = addFormFields(new BCFormController({}, { submitSuffix: "funds/bank-loc" }), true);
  const formActions = ["save-new", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} onBlur={handleOnBlur} />;
};

const EditBankLocForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`funds/bank-loc/${id}`);
  const myForm = addFormFields(new BCFormController(data, { submitSuffix: "funds/bank-loc", deleteSuffix: "/funds/bank-loc", clearSuffixesOnSubmit: [`funds/bank-loc/${id}`] }));
  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions} onBlur={handleOnBlur} />;
};

const LmsFundsBankLoc = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (<React.Fragment>
    {isMainPage && <MainTable/>}
    {isAdd && <AddBankLocForm/>}
    {isEdit && <EditBankLocForm id={id}/>}
  </React.Fragment>);
};

export default LmsFundsBankLoc;